import { FC } from "react";
import { observer } from "mobx-react-lite";

import { Row, Col } from "antd";
import { Controller } from "react-hook-form";
import { useHandleForm } from "../../../../hooks/useHandleForm";
import { FileField, ExpandedTable, IButton, StoredPagination } from "../../../../ui-kit";
import sitPanelReports from "../../../../store/sitPanelReportsStore";

import styles from "./SitPanelReports.module.scss";


const ReportForm: FC = observer(({context, record}) => {

  const onUploadFile = async (files) => {
    const formData = new FormData();
    formData.append("file", files[0]);

    await sitPanelReports.uploadReportFile(record.id, formData);
    await context.getReports();
  };

  return (
    <div className = {styles.SitPanelReportsDateRange}>
      <Row gutter={[15, 20]}>
        <Col span={4}>
          <FileField
            onChange={onUploadFile}
            label="Вложить отчёт"
          ></FileField>
        </Col>
        <Col span={8}>
          <IButton>Сохранить</IButton>
        </Col>
      </Row>
    </div>
  );
});

export default ReportForm;
